export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9506.cbc72f19.jpg";